import {
  Button,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
} from '@material-ui/core';
import { AddCircle, MoreHoriz } from '@material-ui/icons';
import ArrowBack from '@material-ui/icons/ArrowBack';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  IN_ROOM_DINING_COMBO_VIEW,
  IN_ROOM_DINING_ITEMS_VIEW,
  IN_ROOM_DINING_MENU_CREATE,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { updateInRoomDiningMenu } from '../../../../../utils/ServicesAPIUtils';
import { selectedHotelCurrencySelector } from '../../../../property/propertySlice';
import {
  fetchAllInRoomDiningMenu,
  inRoomDiningCombosSelector,
  inRoomDiningItemsSelector,
  inRoomDiningMenuSelector,
} from '../../../servicesSlice';
import CustomAccordionMenu from './Menu-View-Accordion';
import './Menu-View.scss';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const MenuView = (props) => {
  const { selectedMenuForId, hotelId, onViewToggle, setMenuViewObject, permissions, restaurantId } =
    props;
  const [loading, setLoading] = useState(false);
  const currency = useSelector(selectedHotelCurrencySelector);
  const inRoomDiningMenu = useSelector(inRoomDiningMenuSelector);
  const originalIRDItems = useSelector(inRoomDiningItemsSelector);
  const originalIRDCombo = useSelector(inRoomDiningCombosSelector);
  const [selectedMenu, setSelectedMenu] = useState(selectedMenuForId);
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    type: null,
    anchorEl: null,
    objectForView: null,
    isActive: true,
    isGloballyActive: true,
    catIndex: -1,
    subCatIndex: -1,
    itemIndex: -1,
    isCombo: false,
    srcIndex: -1,
  });

  useEffect(() => {
    const tempMenu = inRoomDiningMenu.find((menu) => menu.id === selectedMenuForId.id);
    setSelectedMenu(tempMenu);
  }, [inRoomDiningMenu]);
  const pickCombos = (node) => node?.combo ?? node?.combos ?? [];

  const getMenuItemsNumber = () =>
    selectedMenu?.categories
      ?.map((cat) => {
        const topLevel = (cat?.items?.length || 0) + (pickCombos(cat)?.length || 0);
        const fromSubs =
          cat?.subCategories?.reduce((sum, sc) => {
            const scItems = sc?.items?.length || 0;
            const scCombos = pickCombos(sc)?.length || 0;
            return sum + scItems + scCombos;
          }, 0) || 0;

        return topLevel + fromSubs;
      })
      .reduce((a, b) => a + b, 0);

  const getCategoryItems = (category) => {
    const direct = (category?.items?.length || 0) + (pickCombos(category)?.length || 0);
    const fromSubs =
      category?.subCategories?.reduce((sum, sc) => {
        const scItems = sc?.items?.length || 0;
        const scCombos = pickCombos(sc)?.length || 0;
        return sum + scItems + scCombos;
      }, 0) || 0;
    return direct + fromSubs;
  };

  const goToItem = (obj) => {
    setMenuViewObject(selectedMenu);
    onViewToggle(IN_ROOM_DINING_ITEMS_VIEW, true, obj);
  };

  const goToCombo = (obj) => {
    setMenuViewObject(selectedMenu);
    onViewToggle(IN_ROOM_DINING_COMBO_VIEW, true, obj);
  };

  const handleClose = () => {
    setSelectedValue((prev) => ({
      ...prev,
      anchorEl: null,
    }));
    setTimeout(() => {
      setSelectedValue({
        id: '',
        name: '',
        type: null,
        anchorEl: null,
        objectForView: null,
        isActive: true,
        isGloballyActive: true,
        catIndex: -1,
        subCatIndex: -1,
        itemIndex: -1,
        isCombo: false,
        srcIndex: -1,
      });
    }, 200);
  };

  const handleCellMenuClick = (
    event,
    item,
    catIndex,
    subCatIndex,
    itemIndex,
    isCombo,
    srcIndex,
  ) => {
    const isGloballyActive = Boolean(item?.object?.status);
    const isLinkedActive = item?.isActive ?? true;
    const effectiveActive = isLinkedActive ? isGloballyActive : false;
    
    setSelectedValue({
      id: item.id,
      name: item.name,
      type: item.type,
      anchorEl: event.currentTarget,
      objectForView: item.object,
      isActive: effectiveActive,
      isGloballyActive: isGloballyActive,
      catIndex,
      subCatIndex,
      itemIndex,
      isCombo,
      srcIndex,
    });
  };

  const handleItemStatusChange = async (e) => {
    const payload = { ...selectedMenu };
    payload.categories = payload.categories.map((category, catIndex) => {
      if (catIndex === selectedValue.catIndex) {
        const flip = (val) => !val;
        const isCombo = selectedValue.isCombo;
        const srcIdx = selectedValue.srcIndex;
        if (selectedValue.subCatIndex < 0) {
          if (isCombo) {
            const combo = (category.combo || []).map((c, idx) =>
              idx === srcIdx ? { ...c, isActive: flip(selectedValue.isActive) } : c,
            );
            return { ...category, combo };
          } else {
            const items = (category.items || []).map((item, idx) =>
              idx === selectedValue.itemIndex
                ? { ...item, isActive: flip(selectedValue.isActive) }
                : item,
            );
            return { ...category, items };
          }
        }
        const subCategories = (category.subCategories || []).map(
          (subCategory, subCategoryIndex) => {
            if (subCategoryIndex !== selectedValue.subCatIndex) return subCategory;
            if (isCombo) {
              const combo = (subCategory.combo || []).map((c, idx) =>
                idx === srcIdx ? { ...c, isActive: flip(selectedValue.isActive) } : c,
              );
              return { ...subCategory, combo };
            } else {
              const items = (subCategory.items || []).map((item, idx) =>
                idx === srcIdx ? { ...item, isActive: flip(selectedValue.isActive) } : item,
              );
              return { ...subCategory, items };
            }
          },
        );
        return { ...category, subCategories };
      }
      return category;
    });
    try {
      dispatch(stepUpLoaderCount());
      setSelectedMenu(payload);
      setSelectedValue((v) => ({ ...v, isActive: !v.isActive }));
      await updateInRoomDiningMenu(payload);
      await dispatch(fetchAllInRoomDiningMenu(hotelId, restaurantId));
      notificationManager('success', 'Menu Item status updated successfully');
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to update Menu status');
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
    handleClose();
  };

  const onClickView = () => {
    if (selectedValue.type && selectedValue.objectForView) {
      selectedValue.type === 'Item'
        ? goToItem(selectedValue.objectForView)
        : goToCombo(selectedValue.objectForView);
    }
  };

  const onClickEdit = (e) => {
    onViewToggle(IN_ROOM_DINING_MENU_CREATE, true, selectedMenu);
  };

  const renderItems = (_ignored, categoryIndex, subCategoryIndex) => {
    const cat = selectedMenu?.categories?.[categoryIndex];
    const isSub = subCategoryIndex >= 0;
    const itemsArr = isSub ? cat?.subCategories?.[subCategoryIndex]?.items || [] : cat?.items || [];
    const combosArr = isSub ? pickCombos(cat?.subCategories?.[subCategoryIndex]) : pickCombos(cat);
    const mappedItems = itemsArr.map((it, idx) => {
      const objectInItems = originalIRDItems.find(
        (originalItem) => originalItem.id === it.id,
      );
      if (objectInItems) {
        return {
          ...it,
          type: 'Item',
          object: { ...objectInItems },
          __isCombo: false,
          __srcIndex: idx,
        };
      }
      const objectInCombo = originalIRDCombo?.find(
        (originalCombo) => originalCombo.id === it.id,
      );
      if (objectInCombo) {
        return {
          ...it,
          type: 'Combo',
          object: { ...objectInCombo },
          __isCombo: false,
          __srcIndex: idx,
        };
      }
      return null;
    });

    const mappedCombos = combosArr?.map((cb, idx) => {
      const objectInCombo = originalIRDCombo?.find(
        (originalCombo) => originalCombo.id === cb.id,
      );
      if (objectInCombo) {
        return {
          ...cb,
          type: 'Combo',
          object: { ...objectInCombo },
          __isCombo: true,
          __srcIndex: idx,
        };
      }
      return null;
    });

    const itemsComboToMap = [...mappedItems, ...mappedCombos].filter(Boolean);

    return (
      <div className='item-combo-table mt-1'>
        <TableContainer>
          <Table className='list-table' aria-label='simple table'>
            <TableBody>
              {itemsComboToMap.map((itemKey, key) => (
                <React.Fragment key={`${itemKey.id}-${itemKey.type}-${key}`}>
                  <TableRow>
                    <div className='items-row menu-items-box'>
                      <TableCell className='w-40 no-border'>
                        <span className='gray-text'>
                          {itemKey?.type === 'Combo' ? 'Combo :  ' : 'Item :  '}
                        </span>
                        {itemKey?.object?.name}
                      </TableCell>
                      <TableCell className='w-20 no-border' align='right'>
                        {selectedMenu?.name}
                      </TableCell>
                      <TableCell className='w-20 no-border' align='right'>
                        {currency + ' '}
                        {itemKey?.object?.price}
                      </TableCell>
                      <TableCell align='center' className='no-border'>
                        {(() => {
                          const isGloballyActive = Boolean(itemKey?.object?.status);
                          const isLinkedActive = itemKey?.isActive ?? true;
                          const effectiveActive = isLinkedActive ? isGloballyActive : false;
                          return (
                            <div className='d-flex'>
                              <div
                                className={`${
                                  effectiveActive ? 'pill-active' : 'pill-inactive'
                                } pill d-flex justify-content-center align-items-center`}
                              >
                                <span className='ms-1'>
                                  {effectiveActive ? 'Active' : 'Inactive'}
                                </span>
                              </div>
                            </div>
                          );
                        })()}
                      </TableCell>
                      <TableCell className='w-10 no-border' align='right'>
                        <div className='button-menu'>
                          {permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] ===
                            RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                            <Button
                              aria-controls='simple-menu'
                              aria-haspopup='true'
                              onClick={(e) => {
                                handleCellMenuClick(
                                  e,
                                  itemKey,
                                  categoryIndex,
                                  isSub ? subCategoryIndex : -1,
                                  key,
                                  itemKey.__isCombo,
                                  itemKey.__srcIndex,
                                );
                              }}
                            >
                              <MoreHoriz />
                            </Button>
                          )}
                          <Menu
                            id={itemKey?.id}
                            anchorEl={selectedValue?.anchorEl}
                            open={
                              Boolean(selectedValue?.anchorEl) && selectedValue?.id === itemKey?.id
                            }
                            onClose={handleClose}
                            className='shadow menu-view-kebab-menu'
                            aria-label='kebab-menu-open'
                            key={itemKey?.object?.id}
                          >
                            <Tooltip
                              title={
                                !selectedValue.isGloballyActive
                                  ? "Unable to activate as it's inactive in the main list"
                                  : ''
                              }
                              placement='right'
                            >
                              <span>
                                <MenuItem
                                  className='pe-4'
                                  disabled={!selectedValue.isGloballyActive}
                                  onClick={(e) => {
                                    handleItemStatusChange(e);
                                  }}
                                >
                                  {selectedValue.isActive ? (
                                    <>
                                      <RemoveCircleIcon className='me-2 action-menu-icon' />
                                      Deactivate
                                    </>
                                  ) : (
                                    <>
                                      <AddCircle className='me-2 action-menu-icon' />
                                      Activate
                                    </>
                                  )}
                                </MenuItem>
                              </span>
                            </Tooltip>
                            <MenuItem
                              className='pe-4'
                              onClick={(e) => {
                                onClickView();
                              }}
                            >
                              <VisibilityIcon className='me-2 action-menu-icon' />
                              view
                            </MenuItem>
                          </Menu>
                        </div>
                      </TableCell>
                    </div>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  };

  return (
    <>
      {loading ? (
        <div className='pt-4 col-md-12'>
          <LinearProgressBar />
        </div>
      ) : (
        <div className='container mt-4 mb-3 detail-view-65 pb-4'>
          <div className='mt-5 row mx-3'>
            <div className='col-md-6 px-0 d-flex align-items-center'>
              <Button
                variant='text'
                color='secondary'
                size='small'
                startIcon={<ArrowBack />}
                onClick={(e) => onViewToggle(null, false, null)}
                className='me-2'
              >
                Back
              </Button>
              <span className='page-title'>{selectedMenu.name}</span>
            </div>
            <div
              className='col-md-6 d-flex justify-content-end'
              style={{ height: '35px', marginTop: '30px' }}
            >
              {permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] ===
                RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                <Button
                  variant='outlined'
                  color='primary'
                  size='small'
                  onClick={(e) => onClickEdit(e)}
                >
                  Edit
                </Button>
              )}
            </div>
          </div>
          <div className='card shadow mt-5 mb-4 h-100 mx-4 pb-5 px-4'>
            <div className='row d-flex px-2 mt-4 py-2 menu-name'>
              <div className='col-md-8 details-label'>Menu Name: {selectedMenu.name}</div>
              <div className='col-md-2' align={'right'}>
                {selectedMenu.categories.length} Categories
              </div>
              <div className='col-md-2' align={'right'}>
                {getMenuItemsNumber()} Items
              </div>
            </div>
            <div>
              {selectedMenu.categories.map((category, categoryIndex) => (
                <CustomAccordionMenu
                  category={category}
                  getCategoryItems={getCategoryItems}
                  component='Category'
                  expanded={true}
                  key={categoryIndex}
                >
                  <div className='items-box'>
                    {renderItems(
                      [...category.items, ...(category?.combo || [])],
                      categoryIndex,
                      -1,
                    )}
                    {category.subCategories.map((subCategory, subCategoryIndex) => (
                      <CustomAccordionMenu
                        category={subCategory}
                        key={subCategoryIndex}
                        // getCategoryItems={getCategoryItems}
                        component='Sub Category'
                        expanded={false}
                      >
                        {renderItems(
                          [...subCategory.items, ...(subCategory?.combo || [])],
                          categoryIndex,
                          subCategoryIndex,
                        )}
                      </CustomAccordionMenu>
                    ))}
                  </div>
                </CustomAccordionMenu>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MenuView;
